module.exports = __webpack_public_path__ + "img/lesson_08.0897fce2.jpg";